import React from "react";
import InfoBanner from '../InfoBanner'


/**
 * Componente para mostrar la new Potenciando Estrategías (Contenido estático).
 *
 * @component
 *
 */

export const PotenciandoEstrategias = (props) => {
  const [width, setWidth] = React.useState(window.innerWidth);
  const breakpoint = 620;

  React.useEffect(() => {
    /* Inside of a "useEffect" hook add an event listener that updates
        the "width" state variable when the window size changes */
    window.addEventListener("resize", () => setWidth(window.innerWidth));

    /* passing an empty array as the dependencies of the effect will cause this
        effect to only run when the component mounts, and not each time it updates.
        We only want the listener to be added once */
  }, []);

  const url = window.location.href;

  return (
    <section id="news-detail" className="text-center">
      <div className="col-md-8 col-md-offset-2 section-title">
        <h2>
          <span className="title">News</span>
        </h2>
      </div>
      <InfoBanner
        section={'Potenciando las estrategias'}
        tittle={'Potenciando las estrategias<br/> mediante Martech'}
        readingTime={'Tiempo de lectura 4 minutos'}
        keywords={['Martech', 'Estrategia']}
        urlDesktop={'/img/news/PotenciandoEstrategias/PotenciandoEstrategias_img1.webp'}
        urlMobile={'/img/news/PotenciandoEstrategias/PotenciandoEstrategias_img1_mob.webp'}
      />
      <div className="container-fluid padding-fluid">
        <div className="row">
          <div className="col-md-12 visible-md visible-lg">
            <div className="col-md-1">&nbsp;</div>
          </div>
          <div className="col-md-12 visible-md visible-lg">
            <div className="col-md-1">&nbsp;</div>
          </div>
          <div className="col-md-12 visible-md visible-lg">
            <div className="col-md-1">&nbsp;</div>
          </div>
          <div className="col-md-12">
            <div className="col-md-1">&nbsp;</div>
          </div>
          <article className="col-md-12">
            <div className="col-md-8 col-md-offset-2 text-center">
              <p>
                El término "Martech", que representa la fusión de marketing y tecnología, ha emergido como un concepto revolucionario en el mundo empresarial. Este artículo explora qué es Martech y cómo esta integración de marketing technology está transformando las estrategias de mercadotecnia.
                <br></br>
                <br></br>
                Martech va más allá de ser simplemente una combinación de palabras; es una fusión estratégica que utiliza tecnología en marketing avanzada para mejorar cada aspecto de las estrategias. Desde la segmentación precisa de audiencias hasta la generación optimizada de leads, su objetivo es proporcionar experiencias personalizadas y flujos integrados que permitan una conexión más profunda con los usuarios.
                <br></br>
                <br></br>
              </p>
            </div>
          </article>
        </div>
      </div>
      <div
        className={width < breakpoint ? "" : "container-fluid padding-fluid"}
      >
        <div className={width < breakpoint ? "" : "row"}>
          <div className={width < breakpoint ? "" : "col-md-12"}>
            <div className={width < breakpoint ? "" : "col-md-8 col-md-offset-2 text-center"}>
              <div className="imgWithText">
                <img
                  style={{ width: "100%" }}
                  alt="Potenciando Estrategias"
                  className="img-responsive"
                  src="/img/news/PotenciandoEstrategias/PotenciandoEstrategias_img2.webp"
                ></img>
                <h2 className="img3Text">
                  Más que una simple fusión de palabras, Martech implica una integración estratégica de herramientas y técnicas tecnológicas avanzadas en el marketing.
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <article className="container-fluid padding-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="col-md-8 col-md-offset-2 text-center">
              <p>
                <b>
                  De audiencias a individuos: el papel clave de los "usuarios nominados"
                </b>
                <br></br>
                <br></br>
                Dentro del ámbito martech empresa, el concepto de "usuarios nominados" juega un papel fundamental. Un usuario nominado es aquel que ha sido identificado de manera única, ya sea a través de un ID o clave que permita registrarlo dentro de todos los activos y bases de datos. Esto permite que las empresas se alejen de las audiencias genéricas y enfoquen sus esfuerzos en comunicarse de manera personalizada con usuarios individuales. Esta nominación proporciona la base para la creación de estrategias de marketing altamente efectivas, que aprovechan canales como SMS, correo electrónico, aplicaciones y redes sociales para llegar a los usuarios de manera precisa y oportuna.
                <br></br>
                <br></br>
              </p>
            </div>
          </div>
        </div>
      </article>
      <div
        className={width < breakpoint ? "" : "container-fluid padding-fluid"}
      >
        <div className={width < breakpoint ? "" : "row"}>
          <div className={width < breakpoint ? "" : "col-md-12"}>
            <div className={width < breakpoint ? "" : "col-md-8 col-md-offset-2 text-center"}>
              <div className="imgWithText">
                <img
                  style={{ width: "100%" }}
                  alt="Potenciando Estrategias"
                  className="img-responsive"
                  src="/img/news/PotenciandoEstrategias/PotenciandoEstrategias_img3.webp"
                ></img>
                <h2 className="img3Text">
                  La capacidad ágil de recopilación y análisis de datos mejora la toma de decisiones, permitiendo una comunicación más relevante.
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <article className="container-fluid padding-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="col-md-8 col-md-offset-2 text-center">
              <p>
                <b>
                  Integración de entornos: fortaleciendo la percepción de la marca
                </b>
                <br></br>
                <br></br>
                Un elemento crucial es la integración de diferentes herramientas martech y canales de comunicación. Esta integración no solo mejora la efectividad, sino que también refuerza la percepción de la marca. Cuando los clientes reciben una experiencia personalizada en cada interacción con una marca, se sienten más valorados y comprometidos.
                <br></br>
                <br></br>
                Asimismo, esta tecnología destaca por su capacidad rápida y precisa de recopilar y analizar datos, marcando la diferencia en la toma de decisiones empresariales en el entorno digital. Por eso, aprovechar la inmensa cantidad de información en línea se vuelve crucial, permitiendo una comunicación más relevante.
                <br></br>
                <br></br>
                La automatización también es clave para la eficiencia y la experiencia del cliente, ahorrando tiempo, reduciendo errores y mejorando la interacción. Sin embargo, el éxito del Martech va más allá de herramientas y plataformas; requiere una transformación digital completa de las organizaciones, la estructura y la cultura corporativa para permitir la integración y gestión efectiva de datos.
                <br></br>
                <br></br>
                <b>
                  Solo con una mentalidad receptiva y una adaptabilidad constante, las marcas pueden aprovechar plenamente el potencial del Martech, sentando las bases para la evolución continua.
                </b>
              </p>
            </div>
            <div className="col-md-1 text-left"></div>
            <div
              className="col-md-3 text-left"
              style={{ display: width < breakpoint ? "block" : "none" }}
            >
              <p className="titleShare">COMPARTE</p>
              <div style={{ paddingBottom: "7px" }}>
                <a
                  className="share"
                  href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Facebook
                </a>
              </div>
              <div style={{ paddingBottom: "7px" }}>
                <a
                  className="share"
                  href={`https://twitter.com/intent/tweet?url=${url}&text=Potenciando las estrategias`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Twitter
                </a>
              </div>
              <div style={{ paddingBottom: "7px" }}>
                <a
                  className="share"
                  href={`https://www.linkedin.com/sharing/share-offsite/?url=${url}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  LinkedIn
                </a>
              </div>
              <div style={{ paddingBottom: "7px" }}>
                <a
                  className="share"
                  href={`mailto:?subject=Quiero compartir contigo esta noticia&body=Mira esta noticia ${url}`}
                >
                  Email
                </a>
              </div>
            </div>
          </div>
        </div>
      </article>
    </section>
  );
};
